export default "__VITE_ASSET__Dqn$OgzN__"